module.exports = __webpack_public_path__ + "img/recommed-img7.fa322f84.jpg";